import { render, staticRenderFns } from "./PlacementTest.vue?vue&type=template&id=7916bf48&scoped=true"
import script from "./PlacementTest.vue?vue&type=script&lang=js"
export * from "./PlacementTest.vue?vue&type=script&lang=js"
import style0 from "./PlacementTest.vue?vue&type=style&index=0&id=7916bf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7916bf48",
  null
  
)

export default component.exports